import React, {useEffect, useState} from 'react';
import ProductFilters from "../../../pod/components/product/product-filters";
import {searchPods} from "../../../pod/services/pod-data-service";
import {searchThemes} from "../../../theme/services/theme-data-service";
import _ from "lodash";
import {searchDesigns} from "../../services/design-data-service";
import ShowProductColorTags from "../common/show-product-color-tags";
import ShowDesignVariantStatus from "../common/show-design-variant-status";
import {getAllDesignVariants} from "../../services/design-variant-data-service";
import ShowDesignDetail from "../common/show-design-detail";
import SelectColorTypeDetails from "../design-editor/settings/select-color-type-details";
import {
    prepareSelectedSize,
    processDisplayTextDetail,
    processTextItemsLayer,
    setSettingsToTextItems
} from "../../utils/design-variant-util";
import {processColorDetails} from "../../../common/utils/color-util";


const CopyDesignVariants = ({currentDesignDetail, copyDesignVariantList}) => {
    const [showModal, setShowModal] = useState(false);
    const [filterCriteria, setFilterCriteria] = useState(null);
    const [podList, setPodList] = useState(null);
    const [selectedDesign, setSelectedDesign] = useState(null);
    const [selectedPod, setSelectedPod] = useState(null);
    const [themeList, setThemeList] = useState(null);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);
    const [bulkUpdate, setBulkUpdate] = useState(true);
    const [excludeTemplate, setExcludeTemplate] = useState(true);
    const [designList, setDesignList] = useState([]);
    const [designVariantDetailList, setDesignVariantDetailList] = useState([]);
    const [selectedDesignVariants, setSelectedDesignVariants] = useState([]);

    const handleConfirmAction = () => {
        const selectedDesignVariantList = [];
        const existingSelectedVariants = [...selectedDesignVariants];
        let existingDesign = {...selectedDesign};
        const existingDesignVariantDetailList = [...designVariantDetailList];
        const existingDesignVariantDetailMap = _.keyBy(existingDesignVariantDetailList, 'id');

        _.forEach(existingDesign.variants, variant => {
            if (_.indexOf(existingSelectedVariants, variant?.id) !== -1) {
                const designVariantDetail = existingDesignVariantDetailMap[variant?.id];

                if (designVariantDetail) {
                    variant.background = designVariantDetail.settings.background;
                }

                selectedDesignVariantList.push(variant);
            }
        });

        copyDesignVariantList(selectedDesignVariantList, existingDesign, excludeTemplate);
        setShowModal(false);
    }

    const handleCancelAction = () => {
        setShowModal(false);
    }

    useEffect(() => {
        if (selectedDesign) {
            getSelectedDesignVariantDetails();
        }
    }, [selectedDesign]);

    useEffect(() => {
        if (showModal) {
            setFilterCriteria({});
            getAllPodList();
            getAllThemeList();
            handleSearchDesigns();
        }
    }, [showModal]);

    const getAllPodList = async () => {
        const podListResult = await searchPods('');
        setPodList(podListResult);
    }

    const getAllThemeList = async () => {
        const themeListResult = await searchThemes('');
        setThemeList(_.orderBy(themeListResult, ['startText']));
    }

    const handleSearchDesigns = async () => {
        const searchCriteriaList = [];
        if (selectedPod) {
            searchCriteriaList.push({field: 'podId', condition: '==', value: selectedPod?.id});
        }

        _.forIn(filterCriteria, (value, field) => {
            if (!_.isEmpty(value)) {
                searchCriteriaList.push({field: field, condition: '==', value: value});
            }
        });

        const designsListResult = await searchDesigns(searchCriteriaList);
        setDesignList(designsListResult);
        setSelectedDesign(designsListResult[0]);
        setDataFetchInProgress(false);
    }

    const handleDetailChanges = (event) => {
        const {name, value} = event.target;
        filterCriteria[name] = value;
        setFilterCriteria(filterCriteria);

        if (name === 'podId') {
            const existingPodList = [...podList];
            const podsMap = _.keyBy(existingPodList, 'id');
            setSelectedPod(podsMap[value]);
        } else if (name === 'themeId') {
            handleSearchDesigns();
        }
    }

    const addOrRemoveDesignVariant = (designVariant) => {
        let existingSelectedVariants = [...selectedDesignVariants];
        const existingIndex = _.indexOf(existingSelectedVariants, designVariant.id);

        if (existingIndex === -1) {
            existingSelectedVariants.push(designVariant.id);
        } else {
            delete existingSelectedVariants[existingIndex];
            existingSelectedVariants = _.compact(existingSelectedVariants);
        }

        setSelectedDesignVariants(existingSelectedVariants);
    }

    const selectAllDesignVariants = () => {
        let existingDesign = {...selectedDesign};
        const variants = _.map(existingDesign?.variants, 'id');
        setSelectedDesignVariants(variants);
    }

    const clearAllDesignVariants = () => {
        setSelectedDesignVariants([]);
    }

    const getSelectedDesignVariantDetails = async () => {
        const designVariantListResult = await getAllDesignVariants(selectedDesign?.id);
        setDesignVariantDetailList(designVariantListResult);
    }

    const handleBulkUpdateSettingsChanges = (event, background, designVariant) => {
        const {name, value, type} = event.target;
        const existingDesignVariantDetail = {...designVariant};
        const existingDesignVariantDetailList = [...designVariantDetailList];
        const itemIndex = _.findIndex(existingDesignVariantDetailList, ['id', existingDesignVariantDetail.id]);

        if (type === 'checkbox') {
            existingDesignVariantDetailList[itemIndex].settings[name] = !existingDesignVariantDetailList[itemIndex][name];
        } else {
            existingDesignVariantDetailList[itemIndex].settings[name] = value;
        }

        setDesignVariantDetailList(existingDesignVariantDetailList);
    }

    return (
        <>
            <div className="flex items-center justify-center">
                <button
                    className="button-green-outline py-2 px-4"
                    onClick={() => {
                        clearAllDesignVariants();
                        setShowModal(true);
                    }}>
                    <span>Copy Design Variants</span>
                </button>
            </div>
            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-4/5 my-6">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex justify-between items-center px-5 pt-6 rounded-t">
                                    <h3 className="text-3xl font-bold">Copy Design Variants</h3>

                                    <div className="">
                                        <ShowDesignDetail designDetail={currentDesignDetail}/>
                                    </div>

                                    <div className="flex justify-center items-center">
                                        <div className="field-container">
                                            <div className="justify-start flex">
                                                <input
                                                    type="checkbox"
                                                    className="h-6 w-6 mr-1"
                                                    id="bulkUpdate"
                                                    name="bulkUpdate"
                                                    checked={bulkUpdate}
                                                    onChange={() => {
                                                        setBulkUpdate(!bulkUpdate);
                                                    }}>
                                                </input>
                                                <div className=''>
                                                    <label className='field-label self-center ml-1'
                                                           htmlFor='bulkUpdate'>Bulk Update</label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="field-container">
                                            <div className="justify-start flex">
                                                <input
                                                    type="checkbox"
                                                    className="h-6 w-6 mr-1"
                                                    id="excludeTemplate"
                                                    name="excludeTemplate"
                                                    checked={excludeTemplate}
                                                    onChange={() => {
                                                        setExcludeTemplate(!excludeTemplate);
                                                    }}>
                                                </input>
                                                <div className=''>
                                                    <label className='field-label self-center ml-1'
                                                           htmlFor='excludeTemplate'>Exclude Template</label>
                                                </div>
                                            </div>
                                        </div>

                                        <button onClick={selectAllDesignVariants}
                                                className="button-green px-4 h-10">
                                            Select All
                                        </button>

                                        <button onClick={clearAllDesignVariants}
                                                className="button-gray px-4 h-10 ml-2">
                                            Clear All
                                        </button>
                                    </div>
                                </div>
                                {/*body*/}
                                <div
                                    className="relative p-6">

                                    <div className="flex justify-between -mt-4 -ml-2">

                                        <div className="flex justify-start">
                                            <div className="field-container">
                                                <div className="field-label">
                                                    Theme
                                                </div>
                                                <select
                                                    className="input-field"
                                                    id="themeId"
                                                    name="themeId"
                                                    value={filterCriteria?.themeId}
                                                    onChange={handleDetailChanges}>
                                                    <option value="">Choose Theme</option>
                                                    {themeList?.map((theme, index) => (
                                                        <option key={index}
                                                                value={theme?.id}>{theme?.startText}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="field-container">
                                                <div className="field-label">
                                                    POD <span
                                                    className="text-gray-400">({podList?.length})</span>
                                                </div>
                                                <select
                                                    className="input-field"
                                                    id="podId"
                                                    name="podId"
                                                    value={filterCriteria?.podId}
                                                    onChange={handleDetailChanges}>
                                                    <option value="">Choose POD</option>
                                                    {podList?.map((pod, index) => (
                                                        <option key={index}
                                                                value={pod?.id}>{pod?.displayLabel}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {selectedPod &&
                                                <div className="">
                                                    <ProductFilters
                                                        searchProductsList={handleSearchDesigns}
                                                        filterCriteria={filterCriteria}
                                                        setFilterCriteria={setFilterCriteria}
                                                        clearFilterCriteria={undefined}
                                                        podDetail={selectedPod}
                                                        hideColorsAndSizes={true}/>
                                                </div>
                                            }
                                        </div>

                                    </div>

                                    <div className="flex justify-center pt-2">

                                        <div
                                            className="w-1/2 justify-center content-start copy-design-variant-section-container overflow-y-scroll border border-purple-600 rounded mr-4 p-4 bg-gray-200">
                                            {designList?.map((design, index) => (
                                                <div key={index}
                                                     onClick={() => {
                                                         setSelectedDesign(design);
                                                     }}
                                                     className={`shadow-lg text-neutral-600 hover:bg-purple-50 hover:border hover:border-purple-600 rounded m-2 pb-6 cursor-pointer
                                                     ${selectedDesign?.id === design?.id ? 'bg-purple-100 text-purple-700 shadow-xl border border-purple-600' : 'border-gray-400 bg-white'}`}>

                                                    <div className="px-4 pt-6">
                                                        <div className="h-24 -mt-2">
                                                            <div className="text-lg">{design?.quoteName}</div>
                                                            <div className="text-sm">{design?.themeName}</div>
                                                            <div className="font-bold">{design?.parent}
                                                                {design?.size &&
                                                                    <span className=""> | {design?.size}</span>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="flex justify-between">
                                                            <div className="mt-1">
                                                                <div
                                                                    className="font-bold text-purple-700">{design?.podName}</div>
                                                                <div className="text-sm">{design?.category}</div>
                                                            </div>

                                                            {design?.variants?.length > 0 &&
                                                                <div className="mt-1">
                                                                    <div
                                                                        className="font-bold text-purple-700 flex justify-center">{design?.variants?.length}</div>
                                                                    <div className="text-sm">Variants</div>
                                                                </div>
                                                            }

                                                            {design?.statistics?.inDesign > 0 &&
                                                                <div className="mt-1">
                                                                    <div
                                                                        className="font-bold text-gray-700 flex justify-center">{design?.statistics?.inDesign}</div>
                                                                    <div className="text-sm">In Design
                                                                    </div>
                                                                </div>
                                                            }

                                                            {design?.statistics?.published > 0 &&
                                                                <div className="mt-1">
                                                                    <div
                                                                        className="font-bold text-purple-700 flex justify-center">{design?.statistics?.published}</div>
                                                                    <div className="text-sm">Published
                                                                    </div>
                                                                </div>
                                                            }

                                                            {design?.statistics?.readyToPublish > 0 &&
                                                                <div className="mt-1">
                                                                    <div
                                                                        className="font-bold text-green-700 flex justify-center">{design?.statistics?.readyToPublish}</div>
                                                                    <div className="text-sm">Ready
                                                                        To Publish
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>

                                                </div>
                                            ))}
                                        </div>

                                        <div
                                            className="flex flex-wrap w-full justify-start content-start copy-design-variant-section-container overflow-y-scroll border border-purple-600 rounded bg-gray-200 py-3 px-2">

                                            {selectedDesign?.variants?.map((variant, index) => (
                                                <div key={index}
                                                     onClick={() => {
                                                         addOrRemoveDesignVariant(variant);
                                                     }}
                                                     className={'w-1/2 pb-2'}>
                                                    <div
                                                        className={`flex justify-between mx-1 cursor-pointer rounded border h-full
                                                        ${selectedDesignVariants.indexOf(variant?.id) !== -1 ? 'bg-purple-100 text-purple-700 shadow-xl border-4 border-purple-600' : 'bg-white'}`}>

                                                        <div className="p-4 align-middle flex justify-between">
                                                            <div className="flex justify-start">
                                                                <div
                                                                    className="font-semibold mr-2">#{index + 1}</div>
                                                                <div>
                                                                    <div
                                                                        className="align-middle">{variant?.name}</div>
                                                                    <div className="">
                                                                        {variant?.colors?.length > 0 &&
                                                                            <ShowProductColorTags parent={variant}/>
                                                                        }

                                                                        {!variant?.colors &&
                                                                            <div
                                                                                className="text-red-400 font-semibold ml-1">No
                                                                                Product Colors</div>
                                                                        }
                                                                    </div>

                                                                    <div
                                                                        className="w-full mt-2">
                                                                        <ShowDesignVariantStatus
                                                                            designVariantDetail={variant}/>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            ))}

                                        </div>

                                        {bulkUpdate &&
                                            <div
                                                className="ml-4 flex flex-wrap w-full justify-start content-start copy-design-variant-section-container overflow-y-scroll border border-purple-600 rounded bg-white py-3 px-2">

                                                {designVariantDetailList?.map((designVariant, index) => (
                                                    <React.Fragment key={`design-variant-${index}`}>
                                                        {selectedDesignVariants?.indexOf(designVariant?.id) !== -1 &&

                                                            <div className={'w-full pb-2'}>
                                                                <div
                                                                    className={`flex justify-between mx-1 rounded border h-full bg-gray-100`}>

                                                                    <div
                                                                        className="p-4 align-middle flex justify-between">
                                                                        <div className="flex justify-start">
                                                                            <div
                                                                                className="font-semibold mr-2">#{index + 1}</div>

                                                                            <div>
                                                                                <SelectColorTypeDetails
                                                                                    label={'Background Color & Shade'}
                                                                                    parentForm={designVariant?.settings?.background}
                                                                                    colorAttribute={'background'}
                                                                                    colorKeyAttribute={'backgroundColorKey'}
                                                                                    colorCodeKeyAttribute={'backgroundColorCodeKey'}
                                                                                    settings={designVariant?.settings}
                                                                                    handleColorDetailsChanges={(event, background) => {
                                                                                        handleBulkUpdateSettingsChanges(event, background, designVariant);
                                                                                    }}
                                                                                    handleClearColorDetailsChanges={undefined}/>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        }
                                                    </React.Fragment>

                                                ))}

                                            </div>
                                        }
                                    </div>

                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-center px-6 pb-6 rounded-b">
                                    <button
                                        className="text-gray-500 border border-gray-500 h-10 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleCancelAction}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-10 rounded px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm Selected Design Variants
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default CopyDesignVariants
